import { Directive, HostListener, inject, input, output } from '@angular/core';

import type { ConfigConfirmDialog } from './config';
import { ConfirmDialogService } from './confirm-dialog.service';

@Directive({
  selector: '[appConfirmDialog]',
  standalone: true,
})
export class ConfirmDialogDirective {
  readonly #confirmDialogService = inject(ConfirmDialogService);

  config = input<ConfigConfirmDialog | undefined>(undefined);
  disabled = input<boolean | undefined>(undefined);
  confirmed = output<boolean>();

  @HostListener('click')
  openDialog(): void {
    const config = this.config();

    if (!config || this.disabled()) {
      return;
    }
    this.#confirmDialogService.open(config, (res) => this.confirmed.emit(res));
  }
}
